import React from 'react'
import { connect } from 'react-redux'
import {
  setDisplayName,
  compose
} from 'recompose'
import { getUserInfo } from 'Features/auth/selectors'

const withO365UserInfo = WrappedComponent => props => (
  <WrappedComponent {...props} O365UserInfo={props.userInfo} />
)

export default WrappedComponent => compose(
  setDisplayName('withO365UserInfo'),
  connect(
    state => ({
        userInfo: getUserInfo(state)
    })
  ),
  withO365UserInfo
)(WrappedComponent)


// WEBPACK FOOTER //
// ./src/lib/withO365UserInfo.js